export const ROUTES = {
  BASE: "/",
  TERMS_AND_CONDITIONS: "/terms-and-conditions",
  PRIVACY_POLICY: "/privacy-policy",
  ACCESSIBILITY_STATEMENT:"/accessibility-statement",
  HOW_WE_RATE:"/how-we-rate",
  CCPA_PRIVACY_NOTICE:"/ccpa-privacy-notice",
  RESPOSIBLE_GAMBLING:"/responsible-gambling",
};